import { render, staticRenderFns } from "./MessageEditorLocation.vue?vue&type=template&id=184752c1&scoped=true&"
import script from "./MessageEditorLocation.vue?vue&type=script&lang=js&"
export * from "./MessageEditorLocation.vue?vue&type=script&lang=js&"
import style0 from "./MessageEditorLocation.vue?vue&type=style&index=0&id=184752c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184752c1",
  null
  
)

export default component.exports